module.exports = __webpack_public_path__ + "static/media/PN.250c320b.svg";